import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie'
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { stringify } from 'query-string'
import withHooks from 'cityads-v3/decorators/withHooks'
import { useThemeChanger } from 'cityads-v3/hooks/theme'
import i18n from 'cityads-v3/i18n';

import { checkAuth } from 'cityads-v3/actions/auth';

import Dialog from 'cityads-v3/components/Dialog/Dialog';
import HomeWidgetLoading from 'cityads-v3/components/Home/Widgets/Loading';

import RegisterAdvertiserForm from './RegisterAdvertiserForm';
import AuthIFrame from './AuthIFrame';

import { yandexReachGoal, amplitudeSendEvent } from 'cityads-v3/utils/counterUtils';

import config from 'cityads-v3/config';

import classNames from './LoginDialog.scss';

const AMPLITUDE_USER_TYPE = {
  webmaster: 'вебмастер',
  advertiser: 'рекламодатель',
  blogger: 'блогер'
}

@withCookies
@withRouter
@withHooks(props => ({
  ...props,
  themeChanger: useThemeChanger()
}))
@withTranslation(['main'], { i18n, wait: false })
export class RegistrationDialog extends Component {
  static propTypes = {
    dispatch        : PropTypes.func.isRequired,
    language        : PropTypes.string,
    isCheckingAuth  : PropTypes.bool,
    isSettingUid    : PropTypes.bool,
    isSettingClickId: PropTypes.bool,
    onRequestClose  : PropTypes.func,
    tab             : PropTypes.string,
    onTabChange     : PropTypes.func,
    cookie          : PropTypes.string,
    closeLink: PropTypes.any,
  }

  constructor(props) {
    super(props);

    this.sendAmplitudeEventBlogger = this.sendAmplitudeEvent.bind(this, AMPLITUDE_USER_TYPE.blogger);
    this.sendAmplitudeEventWebmaster = this.sendAmplitudeEvent.bind(this, AMPLITUDE_USER_TYPE.webmaster);
    this.sendAmplitudeEventAdvertiser = this.sendAmplitudeEvent.bind(this, AMPLITUDE_USER_TYPE.advertiser);
  }

  componentDidMount() {
    const { dispatch, isCheckingAuth, cookie } = this.props;

    if (!isCheckingAuth) {
      dispatch(checkAuth({ cookies: cookie }))
        .catch(() => console.warn('Not logged in'))
      ;
    }
  }

  getCookie(name) {
    if(window) {
      const value = "; " + window.document.cookie;
      const parts = value.split("; " + name + "=");
      if (parts.length === 2) {
        return parts.pop().split(";").shift();
      }
    } else {
      return false;
    }
  }

  onRegistrationEvent(evt) {
    const { event } = evt.data;

    if (event === 'register_success') {
      yandexReachGoal('REGISTRATION_COMPLETE');
    }
  }

  sendAmplitudeEvent(registration_type) {
    const { location } = this.props;

    amplitudeSendEvent('makeConversions', 'd-v1-e1', 'registration', 'form_view', {
      registration_type,
      is_red_button: location.state?.source === 'AppFabContainer'
    });
  }

  getLoginDialogTabs() {
    const { language, isSettingUid, isSettingClickId, isCheckingAuth, t, cookies, themeChanger } = this.props;
    const promocode = this.getCookie('promocode');
    const registrationUrl = config.AUTH_URL + '/registration' + (promocode ? '/' + promocode : '')
      + '?'
      + stringify({
        theme: 'material',
        lang: language,
        dark_mode: themeChanger.theme.palette.mode === 'dark' ? true : undefined
      })
    const FEATURE_BLOGGER_REGISTRATION = !!cookies?.cookies?.FEATURE_BLOGGER_REGISTRATION;

    const blogger = FEATURE_BLOGGER_REGISTRATION ? [{
      value: 'blogger',
      label: t('blogger'),
      children: (isSettingUid || isSettingClickId || isCheckingAuth) ?
        <HomeWidgetLoading /> :
        <AuthIFrame
          className={classNames.webmasterRegisterFrame}
          src={registrationUrl + '&type=blogger'}
          title={t('registration.title')}
          onEvent={(evt) => this.onRegistrationEvent(evt)}
          onMount={this.sendAmplitudeEventBlogger}
        />
    }] : []

    const publisher = [{
      value: 'publisher',
      label: t('publisher'),
      children: (isSettingUid || isSettingClickId || isCheckingAuth) ?
        <HomeWidgetLoading /> :
        <AuthIFrame
          className={classNames.webmasterRegisterFrame}
          src={registrationUrl}
          title={t('registration.title')}
          onEvent={(evt) => this.onRegistrationEvent(evt)}
          onMount={this.sendAmplitudeEventWebmaster}
        />
    }]

    const advertiser = [{
      value: 'advertiser',
      label: t('advertiser'),
      cta: t('registration.advertiserCta'),
      children: <RegisterAdvertiserForm onMount={this.sendAmplitudeEventAdvertiser} />
    }]

    const tabs = [
      ...blogger,
      ...publisher,
      ...advertiser,
    ];

    return tabs;
  }

  render() {
    return (
      <Dialog
        open           = {true}
        onRequestClose = {this.props.onRequestClose}
        closeLink      = {this.props.closeLink}
        tab            = {this.props.tab}
        onTabChange    = {this.props.onTabChange}
        tabs           = {this.getLoginDialogTabs()}
        fullScreen     = {this.props.isMobile}
      />
    );
  }
}

export default connect(
  state => ({
    language        : state.language.language,
    isCheckingAuth  : state.auth.checkingAuth,
    isSettingUid    : state.auth.referralUidSetting,
    isSettingClickId: state.auth.clickIdSetting,
    cookie          : state.auth.cookie,
    isMobile        : state.app.isMobile,
  })
)(
  RegistrationDialog
);
